import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { IconComponent } from '@shared/components/icon/icon.component';

export type TInfoDialogType = 'error' | 'success' | 'warning' | 'info';

export interface IInfoDialogData {
  title: string;
  message: string;
  closeText: string;
  type: TInfoDialogType;
}

@Component({
  imports: [MatDialogModule, MatButtonModule, IconComponent],
  selector: 'app-info-dialog',
  styles: [
    `
      :host {
        mat-dialog-actions {
          padding: 0;
          padding-top: 16px;
        }

        mat-dialog-content {
          padding: 0;
          padding-top: 8px;
        }
      }
    `,
  ],
  template: `
    <div class="p-6">
      <div class="flex items-center gap-2 mb-1">
        <app-icon [src]="iconSrc" [alt]="data.type" [size]="20" [color]="iconColor" />
        <span class="text-lg">{{ data.title }}</span>
      </div>

      <mat-dialog-content>
        <p>{{ data.message }}</p>
      </mat-dialog-content>

      <mat-dialog-actions align="start">
        <button mat-flat-button color="secondary" [mat-dialog-close]="true">
          {{ data.closeText }}
        </button>
      </mat-dialog-actions>
    </div>
  `,
})
export class InfoDialogComponent {
  public readonly iconSrc!: string;
  public readonly iconColor!: string;

  public readonly data = inject<IInfoDialogData>(MAT_DIALOG_DATA);

  constructor() {
    switch (this.data.type) {
      case 'error':
        this.iconSrc = '/icons/circle-x.svg';
        this.iconColor = 'var(--shikenso-error-base)';
        break;
      case 'warning':
        this.iconSrc = '/icons/warning.svg';
        this.iconColor = 'var(--shikenso-warning-base)';
        break;
      case 'success':
        this.iconSrc = '/icons/circle-check.svg';
        this.iconColor = 'var(--shikenso-success-base)';
        break;
      default:
        this.iconSrc = '/icons/info-circle.svg';
        this.iconColor = 'var(--shikenso-info-base)';
    }
  }
}
